var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7687_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.413086 0.506256H32.6264V18.16H0.413086V0.506256Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7687_303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15311 5.49959C6.83145 6.85626 5.88186 8.51167 6.34311 9.97709C6.7502 11.2525 8.5952 12.365 8.86686 13.5592C9.38228 13.125 9.95228 11.5238 9.9252 10.8996C9.89811 10.4383 9.81645 10.0583 9.70811 9.73292C8.6227 9.57001 7.78145 8.62001 7.78145 7.48042C7.78145 6.23209 8.8127 5.20084 10.0606 5.20084C11.3089 5.20084 12.3402 6.23209 12.3402 7.48042C12.3402 8.24042 11.9602 8.91876 11.3906 9.32584C11.336 9.67834 11.336 10.1671 11.4177 10.8454C11.5806 12.4738 12.6119 13.0163 13.1002 13.315C13.1544 11.985 14.8098 10.0583 14.8369 8.72876C14.891 6.96459 13.3444 5.79792 13.3985 3.97959C14.8098 3.08417 15.9223 1.89001 16.5194 0.506256C17.1164 1.89001 18.2019 3.08417 19.6402 3.97959C19.6673 5.77084 18.1477 6.96459 18.2289 8.72876C18.256 10.0583 19.8844 12.0121 19.9656 13.315C20.4273 13.0163 21.4581 12.4463 21.621 10.8454C21.6752 10.1671 21.6752 9.67834 21.621 9.32584C21.051 8.91876 20.6985 8.24042 20.6985 7.48042C20.6985 6.23209 21.7298 5.20084 22.9781 5.20084C24.2264 5.20084 25.2573 6.23209 25.2573 7.48042C25.2573 8.62001 24.416 9.57001 23.3306 9.73292C23.2223 10.0583 23.1406 10.4113 23.1135 10.8996C23.0864 11.5238 23.6294 13.1521 24.1719 13.5592C24.416 12.3379 26.2885 11.2525 26.6956 9.97709C27.1569 8.51167 26.2344 6.88334 26.8856 5.49959C29.1381 5.22792 31.146 4.33251 32.6114 3.03001C32.3673 4.06126 32.1773 5.09251 31.9873 6.12376C29.1923 10.0313 27.8085 14.0746 27.5098 18.145H5.58311C5.2577 14.0475 3.90061 10.0313 1.10561 6.12376C0.915612 5.09251 0.725612 4.08834 0.481445 3.03001C1.91978 4.33251 3.9277 5.22792 6.1802 5.49959H6.15311Z",
    fill: "#E1BE64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7687_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 18,
    width: 23,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5332 18.9066H27.3999V22.4262H5.5332V18.9066Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7687_303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53747 21.2929L8.51456 20.6962L7.53747 20.0991L6.56081 20.6962L7.53747 21.2929ZM10.0887 21.2929L11.0654 20.6962L10.0887 20.0991L9.11164 20.6962L10.0887 21.2929ZM12.6125 21.2929L13.5891 20.6962L12.6125 20.0991L11.6354 20.6962L12.6125 21.2929ZM16.4658 21.8629L18.4196 20.6962L16.4658 19.5291L14.5121 20.6962L16.4658 21.8629ZM20.3191 21.2929L21.2962 20.6962L20.3191 20.0991L19.3421 20.6962L20.3191 21.2929ZM22.8429 21.2929L23.82 20.6962L22.8429 20.0991L21.8658 20.6962L22.8429 21.2929ZM25.3666 21.2929L26.3708 20.6962L25.3666 20.0991L24.3896 20.6962L25.3666 21.2929ZM6.09956 18.932H26.7779C27.1033 18.932 27.3475 19.2033 27.3475 19.502V21.8629C27.3475 22.1887 27.1033 22.4329 26.7779 22.4329H6.09956C5.77372 22.4329 5.55664 22.1887 5.55664 21.8629V19.502C5.55664 19.1762 5.82789 18.932 6.12664 18.932H6.09956Z",
    fill: "#C49C37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.534b245f3dbd1f29cfd79bc1e51a7c8f.svg";
export { ForwardRef as ReactComponent };